import { Component, OnInit } from '@angular/core';
import { Apollo, QueryRef } from 'apollo-angular';
import gql from 'graphql-tag';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { StaticModuleConsts } from '../../contants';
import { Title } from '@angular/platform-browser';
@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss', '../faq/faq.component.scss'],
    standalone: false
})
export class AboutComponent implements OnInit {
  firstSection: any;
  secondSection: any;
  CONTACT_QUERY = gql`
  query  {
    aboutUsSection1{
      id
      description
	  heading,
      image {
        id
        fileName
        size
        url
      }
    }
    aboutUsSection2{
        id
        description1
		description2
		heading
    }
}
`;
  private query: QueryRef<any>;
  constructor(private apollo: Apollo, public statePersist: StatePersistService,
    private titleService: Title) { }

  ngOnInit(): void {
    this.titleService.setTitle(StaticModuleConsts.ABOUT_US_PAGE_TITLE);
    this.statePersist.setLocalStorage('address-disabled', true)
    this.statePersist.setLocalStorage('retailer-disabled', true)
    this.statePersist.setLocalStorage('product_data', {}, 'search')
    this.statePersist.removeLocalStorage('product_data')
    this.query = this.apollo.watchQuery({
      query: this.CONTACT_QUERY,
      variables: {}
    });
    this.query.valueChanges.subscribe(result => {
      this.firstSection = result.data.aboutUsSection1
      this.secondSection = result.data.aboutUsSection2
      window.scroll({ 
        top: 0, 
        left: 0, 
        behavior: 'smooth' 
      });
    });
  }

}
